import styled from 'styled-components';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const getIconColor = (appearance) => {
    switch (appearance) {
        case 'success':
            return theme.swatches.green[500];
        case 'danger':
            return theme.swatches.red[500];
        case 'warning':
            return theme.swatches.yellow[500];
        case 'info':
        default:
            return theme.swatches.blue[500];
    }
};
export const StyledTitle = styled(Typography) `
  line-height: ${pxToRem(18)};
`;
export const StyledMessage = styled(Typography) `
  line-height: ${pxToRem(18)};
`;
export const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Container = styled.div `
  display: flex;
  align-items: stretch;
  gap: ${theme.spacing.lg};
  padding: ${theme.spacing.lg};
  border-radius: ${theme.borderRadius.lg};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
  background-color: ${theme.semantic.surface.primary};
  box-shadow: ${theme.dropShadow[100]};

  ${(props) => props.$onlyMessage &&
    `
    align-items: center;

    ${ContentContainer} {
      justify-content: center;
      min-height: ${pxToRem(36)};
    }}
  `}
`;
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  border-radius: ${theme.borderRadius.lg};
  background-color: ${theme.semantic.surface.secondary};

  [data-icon='falcon'] {
    color: ${(props) => getIconColor(props.$appearance)};
  }
`;
